import { PhqGadScreen } from '@/components/PhqGadScreen';

export default function PhqGad() {
  return <PhqGadScreen />;
}
